import { StyleProp, StyleSheet } from 'react-native';
import { TextStyle } from '@expo/html-elements/build/primitives/Text';
import { useMemo } from 'react';
import { isSafariOnDesktop } from 'src/_shared/utils/is-safari-on-desktop/isSafariOnDesktop';
import { getWorkSansFontFamily } from 'src/helpers/font.helper';
import { FontStyle } from 'src/constants/font.constants';

export function useWorkSansFont(style: StyleProp<TextStyle> | undefined) {
  const workSansFontStyle = useMemo(() => {
    if (style) {
      return {
        fontFamily: getWorkSansFontFamilyByStyle(style),
      };
    } else {
      return undefined;
    }
  }, [style]);

  return workSansFontStyle;
}

export const getWorkSansFontFamilyByStyle = (style: StyleProp<TextStyle>) => {
  const safariOnDesktop = isSafariOnDesktop();

  const flattenStyle = StyleSheet.flatten(style);
  const fontWeight = flattenStyle.fontWeight;
  const fontStyle = flattenStyle.fontStyle;

  if (fontWeight === 100 && fontStyle === 'italic') {
    return getWorkSansFontFamily(FontStyle.ThinItalic);
  }

  if (fontWeight === 100) {
    return getWorkSansFontFamily(FontStyle.Thin);
  }

  if (fontWeight === 300 && fontStyle === 'italic') {
    return getWorkSansFontFamily(FontStyle.LightItalic);
  }

  if (fontWeight === 300) {
    return getWorkSansFontFamily(FontStyle.Light);
  }

  if (fontWeight === 400 && fontStyle === 'italic') {
    return getWorkSansFontFamily(safariOnDesktop ? FontStyle.LightItalic : FontStyle.Italic);
  }

  if (fontWeight === 400) {
    return getWorkSansFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Regular);
  }

  if (fontWeight === 500 && fontStyle === 'italic') {
    return getWorkSansFontFamily(safariOnDesktop ? FontStyle.LightItalic : FontStyle.MediumItalic);
  }

  if (fontWeight === 500) {
    return getWorkSansFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Medium);
  }

  if (fontWeight === 700 && fontStyle === 'italic') {
    return getWorkSansFontFamily(safariOnDesktop ? FontStyle.LightItalic : FontStyle.BoldItalic);
  }

  if (fontWeight == 700) {
    return getWorkSansFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Bold);
  }

  if (fontWeight == 900 && fontStyle === 'italic') {
    return getWorkSansFontFamily(safariOnDesktop ? FontStyle.LightItalic : FontStyle.BlackItalic);
  }

  if (fontWeight == 900) {
    return getWorkSansFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Black);
  }

  return getWorkSansFontFamily(safariOnDesktop ? FontStyle.Light : FontStyle.Medium);
};
